const cwsBox = document.querySelectorAll(".layers__tab");
const cwsTabs = document.querySelectorAll(".layers__tabs a");
const cwsPanels = document.querySelector(".layers__panels");
const LAYERS_TEXT_HEIGHT_BUFFER = 4;

function getLayerTextTargetHeight(txt) {
  if (!txt) {
    return 0;
  }

  const previousInlineHeight = txt.style.height;
  txt.style.height = "auto";
  const targetHeight = Math.ceil(txt.scrollHeight) + LAYERS_TEXT_HEIGHT_BUFFER;
  txt.style.height = previousInlineHeight;

  return targetHeight;
}

function setLayerTextHeight(txt, options = {}) {
  if (!txt) {
    return;
  }

  const targetHeight = getLayerTextTargetHeight(txt);
  const shouldAnimate = options.animate === true;

  if (!shouldAnimate) {
    txt.style.height = `${targetHeight}px`;
    return;
  }

  const startHeight = Math.ceil(txt.getBoundingClientRect().height);
  txt.style.height = `${startHeight}px`;

  window.requestAnimationFrame(() => {
    txt.style.height = `${targetHeight}px`;
  });
}

function getLayerPanelTargetHeight(panel) {
  if (!panel) {
    return 0;
  }

  const previousInlineHeight = panel.style.height;
  panel.style.height = "auto";
  const targetHeight = Math.ceil(panel.scrollHeight);
  panel.style.height = previousInlineHeight;

  return targetHeight;
}

function setLayerPanelHeight(panel, options = {}) {
  if (!cwsPanels || !panel) {
    return;
  }

  const targetHeight = getLayerPanelTargetHeight(panel);
  const shouldAnimate = options.animate === true;

  if (!shouldAnimate) {
    cwsPanels.style.height = `${targetHeight}px`;
    return;
  }

  const startHeight = Math.ceil(cwsPanels.getBoundingClientRect().height);
  cwsPanels.style.height = `${startHeight}px`;

  window.requestAnimationFrame(() => {
    cwsPanels.style.height = `${targetHeight}px`;
  });
}

function syncActiveLayerTextHeights(scope) {
  const root = scope || document;
  const activeTextBlocks = root.querySelectorAll(".layer.active .layer__txt");

  activeTextBlocks.forEach((txt) => {
    setLayerTextHeight(txt);
  });

  if (root instanceof Element && root.classList.contains("layers__tab")) {
    setLayerPanelHeight(root);
    return;
  }

  const activePanel = document.querySelector(".layers__tab.active");

  if (activePanel) {
    setLayerPanelHeight(activePanel);
  }
}

let layersResizeTimeout;

function scheduleLayersHeightSync() {
  window.clearTimeout(layersResizeTimeout);
  layersResizeTimeout = window.setTimeout(() => {
    syncActiveLayerTextHeights(document);
  }, 80);
}

cwsTabs.forEach((link) => {
  const active = "active";
  const tabs = document.querySelectorAll(".layers__tab");

  link.addEventListener("click", (e) => {
    e.preventDefault();

    const id = link.getAttribute("href").replace("#", "");

    cwsTabs.forEach((link) => {
      link.classList.remove(active);
    });

    tabs.forEach((tab) => {
      tab.classList.remove(active);
    });

    link.classList.add(active);
    const activeTab = document.getElementById(id);

    if (!activeTab) {
      return;
    }

    activeTab.classList.add(active);
    window.requestAnimationFrame(() => {
      syncActiveLayerTextHeights(activeTab);
      setLayerPanelHeight(activeTab, { animate: true });
    });
  });
});

cwsBox.forEach((box) => {
  const cwsLayers = box.querySelectorAll(".layer h3");
  const cwsLinks = box.querySelectorAll(".layers__links a");

  cwsLayers.forEach((btn, index) => {
    if (btn.closest(".layer").classList.contains("active")) {
      const txt = btn.closest(".layer").querySelector(".layer__txt");

      setLayerTextHeight(txt);
    }

    btn.addEventListener("click", () => {
      const parent = btn.closest(".layer");
      const txt = parent.querySelector(".layer__txt");
      const boxes = box.querySelectorAll(".layer");
      const active = "active";

      boxes.forEach((box) => {
        box.classList.remove(active);
        box.querySelector(".layer__txt").style.height = "0px";
      });

      parent.classList.add(active);

      if (txt !== null) {
        setLayerTextHeight(txt, { animate: true });
      }

      window.requestAnimationFrame(() => {
        setLayerPanelHeight(box, { animate: true });
      });

      cwsLinks.forEach((link) => {
        link.classList.remove(active);
      });

      cwsLinks[index].classList.add(active);
    });
  });

  cwsLinks.forEach((link, index) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      cwsLayers[index].click();
    });
  });
});

window.addEventListener("resize", scheduleLayersHeightSync);
window.addEventListener("orientationchange", scheduleLayersHeightSync);

if (cwsPanels) {
  setLayerPanelHeight(document.querySelector(".layers__tab.active"));
}

if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(() => {
    scheduleLayersHeightSync();
  });
}
